"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.write = void 0;
var diveBullets_sidecar_1 = require("@dive/entities/diveBullets-sidecar");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.0';
var namespace = 'bullets';
var item = 'bullet';
function write() {
    var e_1, _a;
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    var objs = diveBullets_sidecar_1.diveBullets.getAll();
    try {
        for (var objs_1 = __values(objs), objs_1_1 = objs_1.next(); !objs_1_1.done; objs_1_1 = objs_1.next()) {
            var c = objs_1_1.value;
            if (c.isDead) {
                continue;
            }
            diveStringSaver_sidecar_1.diveStringSaver.wString(item);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.id);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.timeToLiveTicks);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.tickCount);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.targetCrewId);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.start.i);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.start.j);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.end.i);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.end.j);
            // diveStringSaver.wFloat(c.rotation)
            // diveStringSaver.wFloat(c.dx)
            // diveStringSaver.wFloat(c.dy)
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.damage);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.damageType);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.hitEffect);
            diveStringSaver_sidecar_1.diveStringSaver.wString(c.bulletFrame);
            // TODO: type
            //diveStringSaver.wInt(c.)
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (objs_1_1 && !objs_1_1.done && (_a = objs_1.return)) _a.call(objs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
}
exports.write = write;
function read() {
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveBullets_sidecar_1.diveBullets.killAll();
    while (diveStringSaver_sidecar_1.diveStringSaver.rPeek(item)) {
        diveStringSaver_sidecar_1.diveStringSaver.rString(item);
        var id = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var timeToLive = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var tickCount = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var targetCrewId = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var startI = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var startJ = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var endI = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var endJ = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        // let rotation = diveStringSaver.rFloat()
        // let dx = diveStringSaver.rFloat()
        // let dy = diveStringSaver.rFloat()
        var damage = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var damageType = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var hitEffect = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        var bulletFrame = diveStringSaver_sidecar_1.diveStringSaver.rString();
        var c = diveBullets_sidecar_1.diveBullets.create(id, { i: startI, j: startJ }, { i: endI, j: endJ }, targetCrewId, damage, damageType, hitEffect, bulletFrame);
        // c.dx = dx
        // c.dy = dy
        // c.rotation = rotation
        c.timeToLiveTicks = timeToLive;
        c.tickCount = tickCount;
    }
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
